// extracted by css-extract-rspack-plugin
export default {"container":"_58af0bf","bottomModule":"_c2e8d0cd","headerLeftWrapper":"_b1a42bef","headerLeft":"_2a7d25c","spacer":"_9229d0ce","mainContent":"_99fdd75a"};